var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOperationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8337 3.33331C17.2144 3.33331 18.3337 4.4526 18.3337 5.83331V14.1666C18.3337 15.5474 17.2144 16.6666 15.8337 16.6666H4.16699C2.78628 16.6666 1.66699 15.5474 1.66699 14.1666V5.83331C1.66699 4.4526 2.78628 3.33331 4.16699 3.33331H15.8337ZM3.33366 9.99998V14.1666C3.33366 14.6269 3.70675 15 4.16699 15H15.8337C16.2939 15 16.667 14.6269 16.667 14.1666V9.99998H3.33366ZM3.33366 6.66665H16.667V5.83331C16.667 5.37308 16.2939 4.99998 15.8337 4.99998H4.16699C3.70675 4.99998 3.33366 5.37308 3.33366 5.83331V6.66665Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOperationIcon);
export default __webpack_public_path__ + "static/media/operationIcon.d78cebbf.svg";
export { ForwardRef as ReactComponent };